import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import './_App.scss';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import { ModalController } from 'controls/modals';
import { ErrorBoundary } from 'components/common';
import { Language } from 'language/Language';

import Checkout from 'routes/checkout/Checkout';
import AuthContainer from 'routes/my-account/authContainer/AuthContainer';
import AccountDetails from 'routes/my-account/accountDetails/AccountDetails';
import ForgotPassword from 'components/auth/forgotPassword/ForgotPassword';
import EditUser from 'routes/my-account/editUser/EditUser';
import Product from 'routes/product/Product';
import Orders from 'routes/my-account/orders/Orders';
import OrderDetails from 'routes/my-account/orders/OrderDetails';
import AuthPlugin from 'routes/authPlugin/AuthPlugin';
import Entitlement from 'routes/my-account/entitlement/Entitlement';
import Order from 'routes/my-account/order/Order';
import Subscriptions from 'routes/my-account/subscriptions/Subscriptions';
import SubscriptionDetails from 'routes/my-account/subscriptions/SubscriptionDetails';
import OAuthPlugin from 'routes/authPlugin/OAuthPlugin';
import Voucher from 'routes/voucher/Voucher';
import FreeTrial from 'routes/freeTrial/FreeTrial';

import Loader from 'components/atoms/Spinner/Loader';

export const App = hot(() => {
  const modals = useSelector((state) => state.modals);
  const { userInfo, siteInfo } = useSelector((state) => state);
  const { initializing } = siteInfo;
  const dispatch = useDispatch();
  const language = Language();

  dispatch({ type: 'SET_LANGUAGE', language });

  return (
    <div className='App'>
      <ErrorBoundary>
        <Switch>
          {(initializing && !userInfo) && <Loader />}
          <Route exact path='/jp/私のアカウント' component={userInfo ? AccountDetails : AuthContainer} />
          <Route exact path='/ja/私のアカウント' component={userInfo ? AccountDetails : AuthContainer} />
          <Route exact path='/my-account' component={userInfo ? AccountDetails : AuthContainer} />

          <Route exact path='/jp/チェックアウト' component={userInfo ? Checkout : AuthContainer} />
          <Route exact path='/ja/チェックアウト' component={userInfo ? Checkout : AuthContainer} />
          <Route exact path='/checkout' component={Checkout} />

          <Route exact path='/jp/私のアカウント/order' component={userInfo ? Order : AuthContainer} />
          <Route exact path='/ja/私のアカウント/order' component={userInfo ? Order : AuthContainer} />
          <Route exact path='/my-account/order' component={userInfo ? Order : AuthContainer} />

          <Route exact path='/jp/私のアカウント/products' component={userInfo ? Entitlement : AuthContainer} />
          <Route exact path='/ja/私のアカウント/products' component={userInfo ? Entitlement : AuthContainer} />
          <Route exact path='/my-account/products' component={userInfo ? Entitlement : AuthContainer} />

          <Route exact path='/jp/私のアカウント/edit-account' component={userInfo ? EditUser : AuthContainer} />
          <Route exact path='/ja/私のアカウント/edit-account' component={userInfo ? EditUser : AuthContainer} />
          <Route exact path='/my-account/edit-account' component={userInfo ? EditUser : AuthContainer} />

          <Route exact path='/jp/私のアカウント/orders' component={userInfo ? Orders : AuthContainer} />
          <Route exact path='/ja/私のアカウント/orders' component={userInfo ? Orders : AuthContainer} />
          <Route exact path='/my-account/orders' component={userInfo ? Orders : AuthContainer} />

          <Route exact path='/my-account/subscriptions' component={userInfo ? Subscriptions : AuthContainer} />
          <Route exact path='/my-account/view-subscription' component={userInfo ? SubscriptionDetails : AuthContainer} />

          <Route exact path='/my-account/view-order' component={userInfo ? OrderDetails : AuthContainer} />
          <Route exact path='/jp/私のアカウント/view-order' component={userInfo ? OrderDetails : AuthContainer} />
          <Route exact path='/ja/私のアカウント/view-order' component={userInfo ? OrderDetails : AuthContainer} />

          <Route exact path='/my-account/lost-password' component={ForgotPassword} />
          <Route exact path='/jp/私のアカウント/lost-password' component={ForgotPassword} />
          <Route exact path='/ja/私のアカウント/lost-password' component={ForgotPassword} />

          <Route exact path='/jp/walkmix-creator' component={Product} />
          <Route exact path='/ja/walkmix-creator' component={Product} />
          <Route exact path='/walkmix-creator' component={Product} />

          <Route exact path='/auth/plugin' component={AuthPlugin} />
          <Route exact path='/jp/auth/plugin' component={AuthPlugin} />
          <Route exact path='/ja/auth/plugin' component={AuthPlugin} />

          <Route exact path='/auth' component={OAuthPlugin} />
          <Route exact path='/jp/auth' component={OAuthPlugin} />
          <Route exact path='/ja/auth' component={OAuthPlugin} />

          <Route exact path='/voucher' component={userInfo ? Voucher : AuthContainer} />
          <Route exact path='/jp/voucher' component={userInfo ? Voucher : AuthContainer} />
          <Route exact path='/ja/voucher' component={userInfo ? Voucher : AuthContainer} />

          <Route exact path='/namm90trial' component={FreeTrial} />

        </Switch>
      </ErrorBoundary>
      <ModalController modals={modals} />
    </div>
  );
});
